/*
 * Filters vehicles in the catalog based on their availability in a specified province.
 *
 * @param {Array} catalog - The catalog of vehicles to filter.
 * @param {string} provinceCode - The user location province to filter vehicles by.
 * @returns {Array} The filtered models that are available in the specified province or not attached to any province.
 *
 */
const getVehiclesAvailableInProvince = (catalog, provinceCode) => catalog.filter(vehicle => {
    var _a, _b;
    const availableProvinces = ((_b = (_a = vehicle.availableProvinces) === null || _a === void 0 ? void 0 : _a.items) !== null && _b !== void 0 ? _b : []).map(province => province.name);
    if (Array.isArray(availableProvinces) && availableProvinces.length === 0) {
        return true;
    }
    if (availableProvinces && availableProvinces.includes(provinceCode)) {
        return true;
    }
    return false;
});
export default getVehiclesAvailableInProvince;
